import { Helmet } from 'react-helmet-async';
import IubendaViewer from 'web/components/IubendaViewer';
import React from 'react';
import CenterPageLayoutNew from 'web/components/CenterPageLayoutNew';
import BodyBackground from 'web/styles/BodyBackground';
import styled from 'styled-components';
import ScreenTracker from 'web/components/ScreenTracker';
import themeConstants from 'web/styles/themeConstants';

const PrivacyPolicyStyles = styled.div`
  .iub_header {
    display: none;
  }
  .simple_pp > .one_line_col h2,
  .simple_pp + .one_line_col h2 {
    margin-top: 1em;
    ${themeConstants.typography.h1};
  }
  .simple_pp {
    margin-bottom: 5em;
  }
  .iub_container {
    position: relative;
    z-index: 0;
    padding: 5px 20px 2em;
    margin-left: -20px;
    margin-right: -20px;
    &:before {
      content: '';
      display: block;
      position: absolute;
      background: #fff;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: -1;
    }
    a {
      font-weight: bolder;
      text-decoration: none;
    }
    ul:not(.for_boxes) li {
      margin: 1em 0;
    }
    .one_line_col h2 {
      text-align: left !important;
      font-variant: none !important;
    }
    #purposes_data {
      margin-top: 0;
    }
    h3,
    h4 {
      margin: 2em 0 5px;
    }
    ul.for_boxes {
      list-style-type: none;
      padding: 0;
      .unstyled {
        list-style-type: none;
        padding: 0;
        ${themeConstants.typography.small};
        h3 {
          ${themeConstants.typography.regular};
          margin: 10px 0 0;
        }
        p {
          margin: 0;
        }
      }
    }
  }
`;

const PrivacyPolicy = () => (
  <>
    <Helmet title="Privacy Policy" />
    <ScreenTracker screenName="PrivacyPolicy" />
    <BodyBackground color="#FFEBE0" />
    <CenterPageLayoutNew>
      <PrivacyPolicyStyles>
        <IubendaViewer policyUrl="https://www.iubenda.com/api/privacy-policy/54070999" cypressId="privacy-policy" />
      </PrivacyPolicyStyles>
    </CenterPageLayoutNew>
  </>
);

export default PrivacyPolicy;
